import { ISelectData } from 'components/atoms/SelectComponent';

import { EZpusob } from 'enums/akcionarKorpAkce/zpusob';

export const zpusobSelectData: ISelectData[] = [
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_EVOT',
        value: EZpusob.EVOT
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_MAIL',
        value: EZpusob.MAIL
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_PHNV',
        value: EZpusob.PHNV
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_PHYS',
        value: EZpusob.PHYS
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_PRXY',
        value: EZpusob.PRXY
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_VIRT',
        value: EZpusob.VIRT
    }
];
